'use strict';
var base = require('./base');
var focusHelper = require('base/components/focus');
const { productInfo } = require('./product');

function SizeSelected() {
    if (!window.customer.isB2B) {
        var quantitySelector = $('.b2b-customer.b2c-customer .quantity-select');
        if ($(".size-field.selected").length > 0) {
            $('.add-to-cart-global .label-add-to-cart').removeClass('d-none').addClass('d-block');
            $('.add-to-cart-global .label-select-size').removeClass('d-block').addClass('d-none');
            $('.label-add-to-cart').parents('.add-to-cart-global').removeClass('btn-blue disabled-btn').addClass('btn-primary');
        } else {
            $('.add-to-cart-global .label-select-size').removeClass('d-none').addClass('d-block');
            $('.add-to-cart-global .label-add-to-cart').removeClass('d-block').addClass('d-none');
            $('.label-select-size').parents('.add-to-cart-global').removeClass('btn-primary').addClass('btn-blue disabled-btn');
        }

        if ($(".size-field.selectable").length == 0) {
            $('.add-to-cart-global .label-add-to-cart').removeClass('d-none').addClass('d-block');
            $('.add-to-cart-global .label-select-size').removeClass('d-block').addClass('d-none');
            $('.label-add-to-cart').parents('.add-to-cart-global').removeClass('btn-blue disabled-btn').addClass('btn-primary');
        }

        if ($('.add-to-cart-global').parents('.attributes').find('.variation-container').hasClass('no-size')) {
            $('.add-to-cart-global .label-add-to-cart').removeClass('d-none').addClass('d-block');
            $('.add-to-cart-global .label-select-size').removeClass('d-block').addClass('d-none');
            $('.label-add-to-cart').parents('.add-to-cart-global').removeClass('btn-blue disabled-btn').addClass('btn-primary');
        }

        if ($('.size-field').length > 0) { 
            if ($('.size-field.selected').length === 0) {
                quantitySelector.prop('disabled', true).addClass('btn-qt-disabled');
                $('.quantity-btn').addClass('btn-qt-disabled');
            } else {
                quantitySelector.prop('disabled', false).removeClass('btn-qt-disabled');
                $('.quantity-btn').removeClass('btn-qt-disabled');
            }
        }
        
    } else {
        var quantitySelector = $('.b2b-customer:not(.b2c-customer) .quantity-select');
        if ($(".js-b2b-quantity-select:not(.disabled-select)").length > 0 && $('.js-b2b-quantity-select').val() == "0") {
            $('.add-to-cart-global .label-select-size').removeClass('d-none').addClass('d-block');
            $('.add-to-cart-global .label-add-to-cart').removeClass('d-block').addClass('d-none');
            $('.label-select-size').parents('.add-to-cart-global').removeClass('btn-primary').addClass('btn-blue disabled-btn');
        } else {
            $('.add-to-cart-global .label-add-to-cart').removeClass('d-none').addClass('d-block');
            $('.add-to-cart-global .label-select-size').removeClass('d-block').addClass('d-none');
            $('.label-add-to-cart').parents('.add-to-cart-global').removeClass('btn-blue disabled-btn').addClass('btn-primary');
        }
        $('.js-b2b-quantity-select:not(.disabled-select)').on('change', function () {
            var selectedValue = $(this).val();
        
            if (selectedValue !== "0") { 
                $('.add-to-cart-global .label-add-to-cart').removeClass('d-none').addClass('d-block');
                $('.add-to-cart-global .label-select-size').removeClass('d-block').addClass('d-none');
                $('.label-add-to-cart').parents('.add-to-cart-global').removeClass('btn-blue disabled-btn').addClass('btn-primary');
            } else {
                $('.add-to-cart-global').find('.label-select-size').removeClass('d-none').addClass('d-block');
                $('.add-to-cart-global').find('.label-add-to-cart').removeClass('d-block').addClass('d-none');
                $('.add-to-cart-global').removeClass('btn-primary').addClass('btn-blue disabled-btn');
            }
        });    

        $('.js-b2b-quantity-select:not(.disabled-select)').each(function () {
            if ($(this).val() !== "0") {
                $('.add-to-cart-global .label-add-to-cart').removeClass('d-none').addClass('d-block');
                $('.add-to-cart-global .label-select-size').removeClass('d-block').addClass('d-none');
                $('.label-add-to-cart').parents('.add-to-cart-global').removeClass('btn-blue disabled-btn').addClass('btn-primary');
            }
        });
    }
}

SizeSelected();

var sizeSelector = document.querySelector(".custom-select.select-TEC_size"),
quantitySelector = document.querySelector(".quantity-select"),
addToCartButton = document.querySelector(".add-to-cart-global"),
errorMessage = document.querySelector(".size-error-message");

function Quantity() {
    if (errorMessage && sizeSelector) {
        $(sizeSelector).on("change", function () {
            if ($('.size-field').length > 0) { 
                if ($(".size-field.selected").length === 0) {
                    $(errorMessage).css("display", "none");
                    $(quantitySelector).prop("disabled", false).removeClass("btn-qt-disabled");
                    $(".quantity-btn").removeClass("btn-qt-disabled");
                }
            }
        });
    
        $(quantitySelector).on("click", checkSizeSelection);
        $(addToCartButton).on("click", checkSizeSelection);
    }    

  $(".quantity-btn").on("click", function (event) {
    var quantitySelector = $(".quantity-select");
    var errorMessage = $(".size-error-message");

    if ($(".size-field.selected").length === 0 && $('.size-field').length > 0) {
        event.preventDefault();
        errorMessage.css("display", "block");
        quantitySelector.prop("disabled", true).addClass("btn-qt-disabled");
        $(".quantity-btn").addClass("btn-qt-disabled");
    } else {
        errorMessage.css("display", "none");
        quantitySelector.prop("disabled", false).removeClass("btn-qt-disabled");
        $(".quantity-btn").removeClass("btn-qt-disabled");
    }
});

  $(".size-selector-container").each(function () {
    const $select = $(this).find("select");
    $select.on("focusin", function (e) {
        e.preventDefault();
        $(this).addClass("focused");
      }).on("focusout", function (e) {
        e.preventDefault();
        $(this).removeClass("focused");
      });

    $(this).find(".plus-btn").on("click", function () {
        if ($select.prop("selectedIndex") < $select.find("option").length - 1) {
          $select.prop("selectedIndex", $select.prop("selectedIndex") + 1).trigger("change");
        }
      });

    $(this).find(".minus-btn").on("click", function () {
        if ($select.prop("selectedIndex") > 0) {
          $select.prop("selectedIndex", $select.prop("selectedIndex") - 1).trigger("change");
        }
      });
  });
}

Quantity();

/**
 * Validate size selection in the modal
 */
function checkSizeSelection(event) {
    var sizeSelector = $('#quickViewModal .custom-select.form-control.select-TEC_size');
    if (sizeSelector) {
        if ($('.size-field').length > 0) { 
            if ($(".size-field.selected").length === 0) {
                event.preventDefault();
                $('.quantitySelector').prop('disabled', true).addClass('btn-qt-disabled');
                $('.quantity-btn').addClass('btn-qt-disabled');
            } else {
                $('.quantitySelector').prop('disabled', false).removeClass('btn-qt-disabled');
                $('.quantity-btn').removeClass('btn-qt-disabled');
            }
        }
    }
}

$('.tec-product').on('click',function(){
    var product = $(this).data('ga');
    var product_posi = $(this).closest(".tec-search").data('position');
    dataLayerPushOld({ ecommerce: null }); 
    dataLayerPushOld({
        'event': 'productClick',
        'ecommerce': {
            'click': {
                'products': [{
                    'id': "{" + product.id + "}",
                    'name': "{" + product.productName + "}",
                    'price': "{" + product.price.sales.value + "}",
                    'category': "{" + product.productData.category + "}",
                    'brand': "{" + product.brand + "}",
                    'variant': "{" + product.productData.variant + "}",
                    'position': "{" + product_posi + "}"
                }]
            }
        }
    });
});
/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
    if ($('#quickViewModal').length !== 0) {
        $('#quickViewModal').remove();
    }
    if (navigator.platform.toUpperCase().indexOf('WIN') >= 0) {
        var customLineHeight = "customLineHeight";
     }
    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="quickViewModal" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + `<div class="modal-dialog quick-view-dialog ${customLineHeight ? customLineHeight : ''}">`
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <span class="icone-close"></span>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body tec-scrollbar"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
}

/**
 * @typedef {Object} QuickViewHtml
 * @property {string} body - Main Quick View body
 * @property {string} footer - Quick View footer content
 */

/**
 * Parse HTML code in Ajax response
 *
 * @param {string} html - Rendered HTML from quickview template
 * @return {QuickViewHtml} - QuickView content components
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.product-quickview');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * replaces the content in the modal window on for the selected product variation.
 * @param {string} selectedValueUrl - url to be used to retrieve a new product model
 */
function fillModalElement(selectedValueUrl) {
    $('.modal-body').spinner().start();
    $.ajax({
        url: selectedValueUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            var parsedHtml = parseHtml(data.renderedTemplate);

            $('.modal-body').empty();
            $('.modal-body').html(parsedHtml.body);
            $('.modal-footer').html(parsedHtml.footer);
            $('#quickViewModal .full-pdp-link').attr('href', data.productUrl);
            $('#quickViewModal .size-chart').attr('href', data.productUrl);
            $('#quickViewModal .modal-header .close .sr-only').text(data.closeButtonText);
            $('#quickViewModal .enter-message').text(data.enterDialogMessage);
            $('#quickViewModal').modal('show');
            $('body').trigger('quickview:ready');
            var selectedColor = $('.color-attribute.selected').data('color-selected');
            $('.label-size .color-selected').empty().text(selectedColor);
            $('.label-size .selected-label').removeClass('d-none');
            $(document).on("click", ".size-field", function(event) {
                event.preventDefault();
                event.stopPropagation();
                var $productContainer = $(this).closest('.product-detail');
                var errorMessage = $productContainer.find('.size-error-message');
                $(this).parents('.sizes-container-block').find('.select-size').val($(this).data("attr-value")).trigger('change');
                $(".size-field").removeClass("selected");
                $(this).addClass("selected");
                $('.quantity-select').removeClass('btn-qt-disabled');
                $('.quantity-btn').removeClass('btn-qt-disabled');
                $('.quantity-select').removeAttr('disabled');
                errorMessage.css('display', 'none');
                SizeSelected();
            });
            
            SizeSelected();
            Quantity();
            checkSizeSelection(event);
            productInfo();
            $('.tec-badge span').each(function() {
                if ($(this).text().trim() !== '') {
                    $(this).closest('.tec-badge').addClass('badge-exist');
                }
            });
            $('.quantity-select').select2({
                minimumResultsForSearch: -1,
            }).on('select2:open', () => {
                $(".select2-container--default").addClass('select2-b2b-quantity');
            });
            if ($('.size-field.selected').length === 0 && $('.size-field').length > 0) {
                $("select.quantity-select").html('<option value="0">0</option>');
                $('.label-select-size').parents('.add-to-cart-global').removeClass('btn-primary').addClass('btn-blue disabled-btn');
            }

            var $select = $('.custom-select.select-size');
            var $selectAllSizeContainer = $('.select-all-size');
        
            if ($select.find('option').length > 0) {
                $selectAllSizeContainer.empty();
        
                $select.find('option').each(function () {
                    var $option = $(this);
                    var sizeValue = $option.text().trim();
                    var dataAttrValue = $option.attr('value');
                    var dataProductId = new URL(dataAttrValue).searchParams.get('pid');
                    var isDisabled = $option.is(':disabled') ? 'size-unselectable' : 'selectable';
        
                    if ($selectAllSizeContainer.find(`[data-size-value="${sizeValue}"]`).length === 0) {
                        var sizeBlock = `
                            <div class="sizes-container">
                                <span id="size-field" class="size-field ${isDisabled}" 
                                        data-attr-value="${dataAttrValue}" 
                                        data-product-id="${dataProductId}" 
                                        data-size-value="${sizeValue}">
                                    ${sizeValue}
                                </span>
                            </div>`;
        
                        $selectAllSizeContainer.append(sizeBlock);
                    }
                });
        
                $selectAllSizeContainer.show();
            }

            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}



/**
 * Initialize event listeners for quick view modal
 */
module.exports = {
    showQuickview: function () {
        $('body').on('click', '.quickview', function (e) {
            e.preventDefault();
            var selectedValueUrl = $(this).closest('a.quickview').attr('href');
            $(e.target).trigger('quickview:show');
            getModalHtmlElement();
            fillModalElement(selectedValueUrl);
        });
    },
    focusQuickview: function () {
        $('body').on('shown.bs.modal', '#quickViewModal', function () {
            var errorMessage = $('#quickViewModal .size-error-message')[0];
            if(errorMessage) {
                $('#quickViewModal .custom-select.form-control').on('change', function() {
                    if ($(".size-field.selected").length > 0) {
                        $('#quickViewModal .size-error-message').hide();
                    }
                });

                $('#quickViewModal .quantity-select, #quickViewModal .add-to-cart-global').on('click', checkSizeSelection);
            }
            $('#quickViewModal .close').focus();
        });
    },
    trapQuickviewFocus: function () {
        $('body').on('keydown', '#quickViewModal', function (e) {
            var focusParams = {
                event: e,
                containerSelector: '#quickViewModal',
                firstElementSelector: '.full-pdp-link',
                lastElementSelector: '.add-to-cart-global',
                nextToLastElementSelector: '.modal-footer .quantity-select'
            };
            focusHelper.setTabNextFocus(focusParams);
        });
    },
    availability: base.availability,
    addToCart: base.addToCart,
    showSpinner: function () {
        $('body').on('product:beforeAddToCart', function (e, data) {
            $(data).closest('.modal-content').spinner().start();
        });
    },
    hideDialog: function () {
        $('body').on('product:afterAddToCart', function () {
            $('#quickViewModal').modal('hide');
        });
    },
    beforeUpdateAttribute: function () {
        $('body').on('product:beforeAttributeSelect', function () {
            $('.modal.show .modal-content').spinner().start();
        });
    },
    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('.modal.show .product-quickview>.bundle-items').length) {
                $('.modal.show').find(response.container).data('pid', response.data.product.id);
                $('.modal.show').find(response.container)
                    .find('.product-id').text(response.data.product.id);
            } else if ($('.set-items').length) {
                response.container.find('.product-id').text(response.data.product.id);
            } else {
                $('.modal.show .product-quickview').data('pid', response.data.product.id);
                $('.modal.show .full-pdp-link')
                    .attr('href', response.data.product.selectedProductUrl);
            }
            if ($('.size-field.selected').length === 0 && $('.size-field').length > 0 && $('.size-field.selectable').length > 0 ) {
                $('.label-select-size').parents('.add-to-cart-global').removeClass('btn-primary').addClass('btn-blue disabled-btn');
                $('.add-to-cart-global').find('.label-select-size').removeClass('d-none').addClass('d-block');
                $('.add-to-cart-global').find('.label-add-to-cart').removeClass('d-block').addClass('d-none');
            } else {
                $('.add-to-cart-global').find('.label-select-size').removeClass('d-block').addClass('d-none');
                $('.add-to-cart-global').find('.label-add-to-cart').removeClass('d-none').addClass('d-block');
            }
            if ($('.size-field').length > 0 && $('.size-field.selectable').length < 1 ) {
                $('.label-select-size').parents('.add-to-cart-global').removeClass('btn-blue').addClass('btn-primary disabled-btn');
            }
        });
    },
    updateAddToCart: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            // update local add to cart (for sets)
            $('button.add-to-cart-global', response.$productContainer)
                .toggleClass('disabled-btn', (!response.product.readyToOrder || !response.product.available));

            // update global add to cart (single products, bundles)
            var dialog = $(response.$productContainer)
                .closest('.quick-view-dialog');

            $('.add-to-cart-global', dialog).attr('disabled',
                !$('.global-availability', dialog).data('ready-to-order')
                || !$('.global-availability', dialog).data('available')
            );
            var $productContainer = $(this).closest('.product-detail');
            var errorMessage = $productContainer.find('.size-error-message');
            var sizeSelector = $productContainer.find('.custom-select.form-control.select-TEC_size');
            
            if (sizeSelector.length && errorMessage.length) {
                if ($('.size-field.selected').length === 0) {
                    errorMessage.css('display', 'block');
                    event.preventDefault();
                    return;
                } else {
                    errorMessage.css('display', 'none');
                }
            }
            
            if ($(this).hasClass('disabled-btn')) {
                return;
            }            
        });
    },
    updateAvailability: function () {
        $('body').on('product:updateAvailability', function (e, response) {
            // bundle individual products
            $('.product-availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available)
                .find('.availability-msg')
                .empty()
                .html(response.message);


            var dialog = $(response.$productContainer)
                .closest('.quick-view-dialog');

            if ($('.product-availability', dialog).length) {
                // bundle all products
                var allAvailable = $('.product-availability', dialog).toArray()
                    .every(function (item) { return $(item).data('available'); });

                var allReady = $('.product-availability', dialog).toArray()
                    .every(function (item) { return $(item).data('ready-to-order'); });

                $('.global-availability', dialog)
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);

                $('.global-availability .availability-msg', dialog).empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            } else {
                // single product
                $('.global-availability', dialog)
                    .data('ready-to-order', response.product.readyToOrder)
                    .data('available', response.product.available)
                    .find('.availability-msg')
                    .empty()
                    .html(response.message);
            }
        });
    }
};
